import { selectStockFilter } from './collection-stock-filter.js';

const desktopFilters = window.matchMedia('(min-width: 64rem)');

const setExpanded = (details) => {
  details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
};

const initializeDetails = (details, open) => {
  if (details.dataset.filterDisclosureReady === 'true') return;
  details.open = open;
  setExpanded(details);
  details.dataset.filterDisclosureReady = 'true';
  details.addEventListener('toggle', () => setExpanded(details));
};

const initializeDrawer = (drawer) => {
  initializeDetails(drawer, desktopFilters.matches);
  drawer.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || desktopFilters.matches || !drawer.open) return;
    drawer.open = false;
    drawer.querySelector(':scope > summary')?.focus();
  });
};

const initializeGroup = (group) => {
  initializeDetails(group, group.dataset.defaultOpen === 'true');
};

const updateValueSearch = (input) => {
  const scope = input.closest('[data-filter-group], [data-facet-menu]');
  const list = scope?.querySelector('[data-filter-value-list]');
  if (!list) return;
  const query = input.value.trim().toLocaleLowerCase('vi');
  const expanded = scope.querySelector('[data-filter-show-more]')?.getAttribute('aria-expanded') === 'true';
  let visible = 0;
  list.querySelectorAll('[data-filter-value]').forEach((item) => {
    const matches = !query || item.dataset.filterValue.includes(query);
    const beyondLimit = item.hasAttribute('data-filter-extra') && !expanded && !query;
    item.hidden = !matches || beyondLimit;
    if (!item.hidden) visible += 1;
  });
  scope.querySelector('[data-filter-no-values]')?.toggleAttribute('hidden', visible > 0);
};

const initializeSearch = (input) => {
  if (input.dataset.filterSearchReady === 'true') return;
  input.dataset.filterSearchReady = 'true';
  input.addEventListener('input', () => updateValueSearch(input));
};

const initializeShowMore = (button) => {
  if (button.dataset.showMoreReady === 'true') return;
  button.dataset.showMoreReady = 'true';
  button.setAttribute('aria-expanded', 'false');
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    button.textContent = expanded ? `Xem thêm ${button.dataset.moreCount} lựa chọn` : 'Thu gọn';
    const scope = button.closest('[data-filter-group]');
    scope?.querySelectorAll('[data-filter-extra]').forEach((item) => { item.hidden = expanded; });
    const input = scope?.querySelector('[data-filter-value-search]');
    if (input) updateValueSearch(input);
  });
};

const initializePricePreset = (button) => {
  if (button.dataset.pricePresetReady === 'true') return;
  button.dataset.pricePresetReady = 'true';
  button.addEventListener('click', () => {
    const form = button.closest('form');
    const scope = button.closest('[data-filter-group], [data-facet-menu]') || form;
    const min = scope?.querySelector('input[data-price-min]');
    const max = scope?.querySelector('input[data-price-max]');
    if (!form || !min || !max) return;
    min.value = button.dataset.priceMin || '';
    max.value = button.dataset.priceMax || '';
    scope.querySelectorAll('[data-price-preset]').forEach((preset) => preset.classList.toggle('is-active', preset === button));
    form.requestSubmit();
  });
};

const initializePriceInput = (input) => {
  if (input.dataset.priceInputReady === 'true') return;
  input.dataset.priceInputReady = 'true';
  input.addEventListener('input', () => {
    input.closest('[data-filter-group], [data-facet-menu]')?.querySelectorAll('[data-price-preset]')
      .forEach((preset) => preset.classList.remove('is-active'));
  });
};

const initializeForm = (form) => {
  if (form.dataset.filterFormUiReady === 'true') return;
  form.dataset.filterFormUiReady = 'true';
  form.addEventListener('change', (event) => {
    selectStockFilter(form, event.target);
    if (desktopFilters.matches && event.target.matches('input[type="checkbox"]')) form.requestSubmit();
  });
};

const initializeSortChip = (button) => {
  if (button.dataset.filterSortReady === 'true') return;
  button.dataset.filterSortReady = 'true';
  button.addEventListener('click', () => {
    const section = button.closest('.ptt-collection');
    const select = section?.querySelector('[data-sort-select]');
    if (!select) return;
    select.value = button.dataset.filterSort;
    select.form?.requestSubmit();
  });
};

const initializeFilters = (root = document) => {
  root.querySelectorAll?.('[data-filter-drawer]').forEach(initializeDrawer);
  root.querySelectorAll?.('[data-filter-group]').forEach(initializeGroup);
  root.querySelectorAll?.('[data-facet-menu]').forEach((menu) => initializeDetails(menu, false));
  root.querySelectorAll?.('[data-filter-value-search]').forEach(initializeSearch);
  root.querySelectorAll?.('[data-filter-show-more]').forEach(initializeShowMore);
  root.querySelectorAll?.('[data-price-preset]').forEach(initializePricePreset);
  root.querySelectorAll?.('input[data-price-min], input[data-price-max]').forEach(initializePriceInput);
  root.querySelectorAll?.('[data-collection-filter-form]').forEach(initializeForm);
  root.querySelectorAll?.('[data-filter-sort]').forEach(initializeSortChip);
};

document.addEventListener('mousedown', (event) => {
  document.querySelectorAll('[data-facet-menu][open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-facet-menu][open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
desktopFilters.addEventListener('change', () => {
  document.querySelectorAll('[data-filter-drawer]').forEach((drawer) => {
    drawer.open = desktopFilters.matches;
    setExpanded(drawer);
  });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeFilters(), { once: true });
else initializeFilters();
document.addEventListener('shopify:section:load', (event) => initializeFilters(event.target));
window.addEventListener('pttek:collection:updated', (event) => initializeFilters(event.detail.section));
